import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import { ProtectedRouteProps } from '../interface/interface';
import { getUser, isAuthenticated } from '../services/service';
import { Button, Result } from 'antd';
import { logHelper } from '@/utils';

const TAG = 'ProtectedRouteAdmin: ';
const ProtectedRouteAdmin: React.FC<ProtectedRouteProps> = ({ children }) => {

  const location = useLocation();
  const navigate = useNavigate();

  // logHelper(TAG, ' getUser() ', getUser());

  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const user = getUser();

  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user?.role !== 'admin') {
    window.location.replace('/login');
    return (
      <div className="h-screen flex items-center justify-center bg-gray-50">
        <Result
          status="403"
          title="403"
          subTitle="Sorry, you are not authorized to access this page."
          extra={
            <Button type="primary" onClick={() => navigate('/login')}>
              Back to Login
            </Button>
          }
        />
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRouteAdmin; 